module.exports = __webpack_public_path__ + "img/porsche-marque-donts-01.e8d2edd3.png";